export default "__VITE_ASSET__g5oelh9Z__";